import Model from './../../common/Model';

class DayInRacing extends Model {

	static fieldsInternal() {
		return ['title', 'date', 'body'];
	}

	static parse(attributes) {
		var self = this;
		return super.parse(attributes).then(function (instance) {
			self.parseDate(instance, 'date');
			return instance;
		});
	}

}

export default DayInRacing;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/DayInRacing.js
 **/